
import { Component, Prop, Vue, Emit } from 'vue-property-decorator'
import FieldContainer from './FieldContainer.vue'
@Component({
  components: {
    FieldContainer
  }
})
export default class TextField extends Vue {
  @Prop({ default: '' }) value!: string
  @Prop({ default: '' }) hintHtml!: string
  @Prop({ default: '' }) error!: string
  @Prop({ default: null }) label!: string
  @Prop({ default: false }) required!: boolean
  @Prop({ default: false }) readOnly !: string
  @Prop({ default: '' }) placeholder !: string
  @Prop() minLength!: number
  @Prop() maxLength!: number

  get charCount(): number {
    return this.value.length
  }

  get charCountInfoClass(): string {
    const charCountMatches = this.charCount >= this.minLength && this.charCount <= this.maxLength
    return charCountMatches ? 'text-success' : 'text-danger'
  }

  @Emit('input')
  updateValue(newValue: InputEvent) {
    const input = newValue.target as HTMLInputElement
    return input.value
  }
}
